// firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth} from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBqpU46ZtEolv7ahbmiEm8Hv1m0VoU0uN0",
    authDomain: "shepardstone-website.firebaseapp.com",
    projectId: "shepardstone-website",
    storageBucket: "shepardstone-website.appspot.com",
    messagingSenderId: "980904790347",
    appId: "1:980904790347:web:fc038949048257f66800ce",
    measurementId: "G-XHCMWBRW0T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
